(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[99573],{

/***/ 19506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ ExtensionCheck; }
/* harmony export */ });
var ExtensionCheck = function(extension) {
    switch(extension){
        case "jpg":
        case "jpeg":
        case "png":
        case "tiff":
        case "gif":
            return "image";
        case "wav":
        case "mp3":
        case "aac":
        case "flac":
            return "audio";
        case "mp4":
        case "mov":
        case "webm":
            return "video";
        case "txt":
        case "json":
        case "csv":
            return "text";
        default:
            return "image";
    }
};


/***/ }),

/***/ 37276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ initKakao; },
/* harmony export */   "L": function() { return /* binding */ shareKakao; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97582);


var initKakao = function() {
    if (window.Kakao) {
        var kakao = window.Kakao;
        if (!kakao.isInitialized()) {
            kakao.init("37d6f07b8ece67b826f25e89654bf4e1");
        }
    }
};
var shareKakao = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(linkUrl, title, description) {
        var basicTitle, basicDescription, image, sendTitle, sendDescription, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    basicTitle = "인공지능 서비스 마켓 아이소";
                    basicDescription = "이미지, 데이터 분석 등 다양한 아이소 앱을 사용해보세요.";
                    image = "https://firebasestorage.googleapis.com/v0/b/aiso-api.appspot.com/o/apps%2Fpreview%2Faiso_logo.jpg?alt=media&token=e6014be6-b135-4fdf-bac2-9e86295ffac5";
                    sendTitle = title ? title : basicTitle;
                    sendDescription = description ? description : basicDescription;
                    _tmp = {};
                    /* sendDefault */ return [
                        4,
                        window.Kakao.Link.sendDefault((_tmp.objectType = "feed", _tmp.content = {
                            title: sendTitle,
                            description: sendDescription,
                            imageUrl: image,
                            imageWidth: 1500,
                            imageHeight: 600,
                            link: {
                                mobileWebUrl: linkUrl,
                                webUrl: linkUrl
                            }
                        }, _tmp.buttons = [
                            {
                                title: "아이소로 이동하기",
                                link: {
                                    mobileWebUrl: linkUrl,
                                    webUrl: linkUrl
                                }
                            }, 
                        ], _tmp))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function shareKakao(linkUrl, title, description) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 8522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* reexport safe */ firebaseConfig_config__WEBPACK_IMPORTED_MODULE_0__.vY; }
/* harmony export */ });
/* harmony import */ var firebaseConfig_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36068);


(0,firebaseConfig_config__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)();



/***/ }),

/***/ 46809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_player__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22004);
/* harmony import */ var react_jimp__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39054);






var OneCardPreview = function(param) {
    var type = param.type, url = param.url;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), textFile = ref[0], setTextFile = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        var res, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(type === "text")) return [
                        3,
                        3
                    ];
                    if (!url) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        fetch(url)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        4,
                        res.text()
                    ];
                case 2:
                    result = _state.sent();
                    if (!result.startsWith("�PNG")) {
                        setTextFile(result);
                    }
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        type,
        url
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full",
        onContextMenu: function(e) {
            e.preventDefault();
        },
        children: url ? type === "image" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jimp__WEBPACK_IMPORTED_MODULE_3__/* .Jimage */ .x, {
            src: url
        }) : type === "video" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_player__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            width: "100%",
            height: "100%",
            url: url
        }) : type === "text" ? // <div
        //   className="w-full h-full p-2"
        //   dangerouslySetInnerHTML={{
        //     __html: `<iframe src="${url}}"  width="100%" height="100%"/>`,
        //   }}
        // />
        textFile && textFile !== "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "w-full overflow-y-auto max-h-96",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full h-full text-xs p-1 bg-white",
                children: textFile ? textFile : ""
            })
        }) : "" : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/images/market/no-img.png"
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/images/market/no-img.png"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OneCardPreview);


/***/ }),

/***/ 36170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_icons_GetApp__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43099);
/* harmony import */ var components_appCard_OneCardPreview__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46809);
/* harmony import */ var components_Alert__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34950);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74855);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_icons_Facebook__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(83792);
/* harmony import */ var _material_ui_icons_Twitter__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(44704);
/* harmony import */ var _material_ui_icons_Link__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(66081);
/* harmony import */ var components_KakaoShare__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37276);












/* 파일 업로드 영역 */ var AppRunResult = function(param) {
    var runApp = param.runApp, updateData = param.updateData, outputFiles = param.outputFiles, handleFileDownload = param.handleFileDownload, historyId = param.historyId, email = param.email, appName = param.appName, oneLineContent = param.oneLineContent;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {}, [
        updateData
    ]);
    var linkUrl = "https://aiso.ai/result?id=".concat(historyId, "&email=").concat(email);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,components_KakaoShare__WEBPACK_IMPORTED_MODULE_5__/* .initKakao */ .$)();
    }, []);
    var handleKakaoShare = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                (0,components_KakaoShare__WEBPACK_IMPORTED_MODULE_5__/* .shareKakao */ .L)(linkUrl, appName, oneLineContent);
                return [
                    2
                ];
            });
        });
        return function handleKakaoShare() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full mt-2",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "w-full flex flex-col center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full sm:w-4/6 mt-2",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-full mt-3 flex flex-col justify-center text-center",
                    children: !runApp && outputFiles && outputFiles.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            outputFiles.map(function(m, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "w-full center mb-4",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_appCard_OneCardPreview__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            type: m.type,
                                            url: m.url
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "w-full py-2 px-3 bg-gray-input flex items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-333 mb-0",
                                                    children: "output_".concat(index)
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                    className: "btn btn-white w-48 btn-sm mt-2 md:mt-0",
                                                    onClick: function() {
                                                        return handleFileDownload("output_".concat(index), m.url, index);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_GetApp__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                            className: "mr-2"
                                                        }),
                                                        " 결과 다운로드"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, m);
                            }),
                            historyId ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "center mt-2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "popup-body flex flex-col justify-center items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                            className: "text-333 font-gmarket-medium text-2xl font-bold mb-4",
                                            children: "Share"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "row w-full",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "col-6 col-sm-3",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "share-card p-3",
                                                        onClick: function() {
                                                            window.open("https://www.facebook.com/sharer.php?u=" + encodeURIComponent(linkUrl));
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "face-share-icon",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Facebook__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                                    fontSize: "large"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "mb-0 font-gmarket-medium text-xs text-888 mt-3",
                                                                children: "facebook"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "col-6 col-sm-3",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "share-card p-3",
                                                        onClick: handleKakaoShare,
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "kakao-share-icon",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    style: {
                                                                        width: "40px",
                                                                        height: "40px"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        className: "p-1",
                                                                        src: "/images/market/kakaotalk.svg",
                                                                        alt: ""
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "mb-0 font-gmarket-medium text-xs text-888 mt-3",
                                                                children: "Kakao Talk"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "col-6 col-sm-3",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "share-card p-3",
                                                        onClick: function() {
                                                            window.open("https://twitter.com/intent/tweet/?url=" + encodeURIComponent(linkUrl));
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "twitter-share-icon",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Twitter__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                                    fontSize: "large"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "mb-0 font-gmarket-medium text-xs text-888 mt-3",
                                                                children: "Twitter"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "col-6 col-sm-3",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_4__.CopyToClipboard, {
                                                        text: linkUrl,
                                                        onCopy: function() {
                                                            (0,components_Alert__WEBPACK_IMPORTED_MODULE_3__/* .BasicAlert */ .N)("공유 링크가 복사되었습니다.");
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "share-card p-3",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "twitter-share-icon",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Link__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                                        fontSize: "large"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    className: "mb-0 font-gmarket-medium text-xs text-888 mt-3",
                                                                    children: "Copy Link"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }) : ""
                        ]
                    }) : ""
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AppRunResult);


/***/ }),

/***/ 53724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ market_FileUploadContent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dropzone/dist/es/index.js + 4 modules
var es = __webpack_require__(32512);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/CloudUpload.js
var CloudUpload = __webpack_require__(12459);
;// CONCATENATED MODULE: ./components/market/DropFileContent.js






var DropFileContent = function(param) {
    var file = param.file, type = param.type, index = param.index, onDrop = param.onDrop;
    var accept = "video/*";
    var text = "";
    switch(type){
        case "video":
            accept = "video/*";
            text = "비디오 파일";
            break;
        case "image":
            accept = "image/*";
            text = "이미지 파일";
            break;
        case "audio":
            accept = "audio/*";
            text = "오디오 파일";
            break;
        case "text":
            accept = ".txt,.csv,.json";
            text = "텍스트 파일";
            break;
    }
    var ref = (0,react.useState)(), dropFile = ref[0], setDropFile = ref[1];
    var ref1 = (0,react.useState)(false), fileUploading = ref1[0], setFileUploading = ref1[1];
    (0,react.useEffect)(function() {
        if (file) {
            setFileUploading(false);
            setDropFile(file);
        }
    }, [
        file
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, {
        accept: accept,
        onDrop: function(e) {
            onDrop(e, type, index);
            setFileUploading(true);
            setDropFile();
        },
        multiple: false,
        children: function(param) {
            var getRootProps = param.getRootProps, getInputProps = param.getInputProps;
            return dropFile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full h-full rounded-md aiso_glass_in_bg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "md:flex items-center font-bold py-3 px-4 inoutput_header",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "whitespace-pre text-base mr-2",
                            children: text
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getRootProps()), {
                        className: "w-full flex flex-col items-center justify-center md:h-52 lg:h-40",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full h-full flex justify-start items-center px-6 py-4 cursor-pointer",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({}, getInputProps())),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-lg text-black font-bold mb-0",
                                    children: dropFile.name
                                })
                            ]
                        })
                    }))
                ]
            }) : fileUploading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full h-full rounded-md aiso_glass_in_bg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "md:flex items-center font-bold py-3 px-4 inoutput_header",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "whitespace-pre text-base mr-2",
                            children: text
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full flex flex-col items-center justify-center p-2 py-4 md:h-52 lg:h-40",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full h-full flex center border-dashed border-2 border-white rounded-md px-2 py-4 cursor-pointer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "circle-loader"
                                })
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full h-full rounded-md aiso_glass_in_bg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "md:flex items-center font-bold py-3 px-4 inoutput_header",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "whitespace-pre text-base mr-2",
                            children: text
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getRootProps()), {
                        className: "w-full flex flex-col items-center justify-center p-2 py-4 md:h-52 lg:h-40",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full h-full flex center border-dashed border-2 border-white rounded-md px-2 py-4 cursor-pointer",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({}, getInputProps())),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-aaa text-lg text-aaa flex items-center mb-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudUpload/* default */.Z, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "ml-3",
                                            children: "이미지 파일 업로드"
                                        })
                                    ]
                                })
                            ]
                        })
                    }))
                ]
            });
        }
    });
};
/* harmony default export */ var market_DropFileContent = (DropFileContent);

;// CONCATENATED MODULE: ./components/market/FileUploadContent.js






/* 파일 업로드 영역 */ var FileUploadContent = function(param) {
    var onDrop = param.onDrop, inputFiles = param.inputFiles, updateData = param.updateData;
    (0,react.useEffect)(function() {}, [
        updateData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "center w-full md:w-1/2 lg:w-2/3 mx-0.5 mt-1 rounded-lg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full",
            children: inputFiles && inputFiles.map(function(m, index) {
                return /*#__PURE__*/ (0,react.createElement)(market_DropFileContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, m), {
                    index: index,
                    key: index,
                    onDrop: onDrop
                }));
            })
        })
    });
};
/* harmony default export */ var market_FileUploadContent = (FileUploadContent);


/***/ }),

/***/ 25287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_editable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18160);
/* harmony import */ var react_bootstrap_editable__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_bootstrap_editable__WEBPACK_IMPORTED_MODULE_2__);



var ParameterContent = function(param) {
    var parameterValue = param.parameterValue, setParameterValue = param.setParameterValue;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "center w-full md:w-1/2 lg:w-2/3 mx-0.5 mt-1 rounded-lg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "w-full rounded-md aiso_glass_in_bg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "md:flex items-center font-bold py-3 px-4 inoutput_header",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "whitespace-pre text-base mr-2",
                        children: "파라미터 입력"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "md:h-52 lg:h-40 py-3",
                    children: parameterValue ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full px-4 flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-full block md:flex",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "flex justify-start text-333 text-base font-bold mb-0 mr-3 mt-3",
                                        children: "type"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-wrap mt-2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "bg-white px-2.5 py-1 mb-0 rounded-full mr-1.5 mt-2",
                                                children: "str"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "bg-white px-2.5 py-1 mb-0 rounded-full mr-1.5 mt-2",
                                                children: "bool"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "bg-white px-2.5 py-1 mb-0 rounded-full mr-1.5 mt-2",
                                                children: "int"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "bg-white px-2.5 py-1 mb-0 rounded-full mr-1.5 mt-2",
                                                children: "float"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-full mt-8",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-full",
                                    children: Object.keys(parameterValue["values"]).map(function(m, i) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "w-full block lg:flex mt-2",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "flex justify-start text-333 text-base font-bold mb-0 mr-3 mt-3",
                                                    children: "".concat(m, "  (").concat(parameterValue["types"][m], ")")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "flex flex-wrap mt-2",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_bootstrap_editable__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                        initialValue: parameterValue["values"][Object.keys(parameterValue["values"])[i]],
                                                        //   isValueClickable
                                                        editText: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "btn glass_in_btn btn-sm ml-3",
                                                            children: "변경"
                                                        }),
                                                        mode: "inline",
                                                        className: "w-full _eitable",
                                                        onSubmit: function(e) {
                                                            /* parameter 변경 값 저장하기 */ var tempData = parameterValue;
                                                            tempData["values"][m] = e;
                                                            setParameterValue(tempData);
                                                        }
                                                    })
                                                })
                                            ]
                                        }, m);
                                    })
                                })
                            })
                        ]
                    }) : ""
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ParameterContent);


/***/ }),

/***/ 14775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49704);
/* harmony import */ var jsonwebtoken__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__);



var jwtToken = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var tokenValue, tokenParseValue, email, sendToken, _tmp, _tmp1, guestTokenValue, tokenParseValue1, guestId, sendToken1, _tmp2, _tmp3;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            tokenValue = window.localStorage.getItem("aisoToken");
            _tmp = {};
            _tmp1 = {};
            if (tokenValue !== "" && tokenValue !== null) {
                tokenParseValue = jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__.verify(tokenValue, "sdkjkdlsAESRcdslkch");
                email = tokenParseValue.email;
                sendToken = jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__.sign((_tmp.email = email, _tmp), "sdkjkdlsAESRcdslkch", (_tmp1.expiresIn = "1d", _tmp1));
                return [
                    2,
                    sendToken
                ];
            }
            guestTokenValue = window.localStorage.getItem("guestToken");
            _tmp2 = {};
            _tmp3 = {};
            if (guestTokenValue !== "" && guestTokenValue !== null) {
                tokenParseValue1 = jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__.verify(guestTokenValue, "sdkjkdlsAESRcdslkch");
                guestId = tokenParseValue1.guestId;
                sendToken1 = jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__.sign((_tmp2.email = guestId, _tmp2), "sdkjkdlsAESRcdslkch", (_tmp3.expiresIn = "1d", _tmp3));
                return [
                    2,
                    sendToken1
                ];
            }
            return [
                2,
                ""
            ];
        });
    });
    return function jwtToken() {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (jwtToken);


/***/ }),

/***/ 73180:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 18104:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 73731:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 4059:
/***/ (function() {

/* (ignored) */

/***/ })

}]);